var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" storage "),_c('pre',[_vm._v("    "+_vm._s(_vm.medias)+"\n  ")]),_vm._l((_vm.medias),function(media){return _c('img',{key:media,class:_vm.$style.media,attrs:{"src":media,"alt":""}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }